import React, { useState, useMemo, useEffect } from 'react';
import { SingleSelect, SingleSelectOption } from '@strapi/design-system/Select';
import { Stack } from '@strapi/design-system/Stack';
import { Button } from '@strapi/design-system/Button';
import { Typography } from '@strapi/design-system/Typography';
import { SearchInput } from '#shared/components/SearchInput';
import sanitizeString from '../../utils/sanitizeString';
import { getFilters } from './utils';
import styles from './FilterBody.module.css';
import { APPLY_FILTER_BUTTON_TEXT, DEFAULT_SEARCH_PLACEHOLDER, FILTER_SELECT_PLACEHOLDER, FILTER_TYPE } from '../../utils/constants';
const FilterBody = ({
  filters,
  prefilters,
  onApplyFilter
}) => {
  const [filterType, setFilterType] = useState();
  const [filterValue, setFilterValue] = useState();
  const currentFilters = useMemo(() => getFilters(prefilters), [prefilters]);
  const currentFilter = useMemo(() => currentFilters.find(({
    value
  }) => value === filterType), [filterType, currentFilters]);
  useEffect(() => {
    setFilterValue(filters.find(filter => filter.filterType === filterType)?.filterValue);
  }, [filterType]);
  const handleApply = () => onApplyFilter({
    filterValue: sanitizeString(filterValue),
    filterType,
    filterMetadata: currentFilter
  });
  const handleEnter = e => {
    if (filterValue && sanitizeString(filterValue) !== '') handleApply();
  };
  return /*#__PURE__*/React.createElement("div", {
    className: styles.container
  }, /*#__PURE__*/React.createElement(Stack, {
    spacing: 2
  }, /*#__PURE__*/React.createElement(SingleSelect, {
    placeholder: FILTER_SELECT_PLACEHOLDER,
    value: filterType,
    onChange: setFilterType
  }, currentFilters.map(({
    label,
    value
  }) => /*#__PURE__*/React.createElement(SingleSelectOption, {
    key: value,
    value: value
  }, label))), currentFilter?.type === FILTER_TYPE.text ? /*#__PURE__*/React.createElement(SearchInput, {
    placeholder: currentFilter.placeholder || DEFAULT_SEARCH_PLACEHOLDER,
    value: filterValue || '',
    onChange: setFilterValue,
    onEnter: handleEnter
  }) : currentFilter?.type === FILTER_TYPE.select ? /*#__PURE__*/React.createElement(SingleSelect, {
    value: filterValue,
    onChange: setFilterValue,
    placeholder: currentFilter.placeholder || FILTER_SELECT_PLACEHOLDER
  }, currentFilter.options.map(({
    label,
    value
  }) => /*#__PURE__*/React.createElement(SingleSelectOption, {
    key: value,
    value: value
  }, label))) : '', /*#__PURE__*/React.createElement("div", {
    className: styles['apply-button-container']
  }, /*#__PURE__*/React.createElement(Button, {
    disabled: !filterValue || !sanitizeString(filterValue),
    variant: "secondary",
    onClick: handleApply
  }, /*#__PURE__*/React.createElement(Typography, {
    className: styles.applyText,
    variant: "omega",
    fontWeight: "bold"
  }, APPLY_FILTER_BUTTON_TEXT)))));
};
export default FilterBody;